import { render, staticRenderFns } from "./CollegeEventPayment.vue?vue&type=template&id=001a0d41&scoped=true"
import script from "./CollegeEventPayment.vue?vue&type=script&lang=js"
export * from "./CollegeEventPayment.vue?vue&type=script&lang=js"
import style0 from "./CollegeEventPayment.vue?vue&type=style&index=0&id=001a0d41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001a0d41",
  null
  
)

export default component.exports